/* eslint-disable no-useless-computed-key */
import { Box, InputLabel, FormControl, MenuItem, TextField, Select, OutlinedInput, withStyles } from '@material-ui/core';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { Fragment, PureComponent } from 'react';
import memoize from 'memoize-one';

//import { TOAST_MESSAGE_SEVERITY_ERROR } from '../layout/types';
import { getTestApiV2, setPageTitle, showToast } from 'modules/layout/layout.actions';
import Log from 'utilities/log';

import { TOAST_MESSAGE_SEVERITY_ERROR } from '../layout/types';
import { GET_VENDORS_FAILURE } from 'modules/authorizations/store/types/dataManagementTypes';
import { getVendors, postVendor } from 'modules/authorizations/store/actions/dataManagement.actions';
import VendorsGrid from './vendorsGrid.component';
import { Button } from '@mui/material';
import { fetchEnumerations } from 'modules/authorizations/utils/fetchDataDetailsService';
import {
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllCurrencies,
  getAllWeightTypes,
  getAllCountries
} from 'modules/enumerations/store/enumerationActions';
import CreateVendorDialog from './createVendorDialog.component';

const ALL_DESIGNATIONS = { id: '00000000-0000-0000-0000-000000000000', title: 'All Designations' };

const styles = theme => ({
  headerContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 100
  },
  designationsTextField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    maxWidth: 300,
    minWidth: 300,
    padding: '8px'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  dialogContentContainer: {
    margin: theme.spacing(5)
  },
});

class VendorsView extends PureComponent {
  state = {
    reassigningRecord: null,
    deletingRecord: null,
    isReassigningRecord: false,
    isDeletingRecord: false,
    isLoading: false,
    selectedStatuses: -1,
    selectedStatusName: '',
    selectedType: -1,
    selectedDesignations: [ALL_DESIGNATIONS],
    selectedDesignationNames: ['All Designations'],
    showCreateVendor: false,
    isLoadingModal: false
  };

  async componentDidMount() {
    this.props.setPageTitle('Partners');

    this.setState({ isLoading: true });

    await fetchEnumerations(this.props);

    if (!this.props.vendors) {
      let { type } = await this.props.getVendors();
      if (type === GET_VENDORS_FAILURE) {
        this.props.showToast('Failed to retrieve vednors, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    this.setState({ isLoading: false });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  handleDesignationsChange = event => {
    const selected = event.target.value;
    const lastClicked = selected[selected.length - 1];
    if (selected.length === 0 || lastClicked?.id === ALL_DESIGNATIONS.id) {
      this.setState({ selectedDesignations: [ALL_DESIGNATIONS] });
    } else {
      this.setState({ selectedDesignations: selected.filter(s => s.id !== ALL_DESIGNATIONS.id) });
    }
  };

  filterSummaries = memoize((vendors, selectedType, selectedStatuses, selectedDesignations) => {
    return vendors.filter(summary => {
      return (
        (selectedStatuses === -1 || (summary.statusId !== null && summary.statusId === selectedStatuses)) &&
        (selectedType === -1 || (summary.vendorTypeId !== null && summary.vendorTypeId === selectedType)) &&
        (selectedDesignations.length <= 0 || (selectedDesignations.length === 1 && selectedDesignations[0].id === ALL_DESIGNATIONS.id) || (summary.designations && summary.designations.length > 0 && summary.designations.some(d => selectedDesignations.some(s => s.id === d.vendorDesignationId))))
      );
    });
  });

  render() {
    Log.trace('RENDER', 'VendorsView');
    const { showCreateVendor, selectedStatuses, selectedType, selectedDesignations } = this.state;
    const { classes, history, isLoading, vendors, enumerations } = this.props;

    let vendorSummaries = this.filterSummaries(
      vendors || [],
      selectedType || -1,
      selectedStatuses || -1,
      selectedDesignations || [ALL_DESIGNATIONS],
    );

    return (
      <Fragment>
        <div className={classes.headerContainer}>
          <TextField
            select
            label="Status"
            className={classes.textField}
            value={selectedStatuses}
            onChange={this.handleChange('selectedStatuses')}
            SelectProps={{
              autoWidth: true
            }}
            variant="outlined"
          >
            <MenuItem value={-1}>
              <em>All Statuses</em>
            </MenuItem>
            {enumerations?.allEnums?.vendorStatuses.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.title}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Partner Type"
            className={classes.textField}
            value={selectedType}
            onChange={this.handleChange('selectedType')}
            SelectProps={{
              autoWidth: true
            }}
            variant="outlined"
          >
            <MenuItem value={-1}>
              <em>All Types</em>
            </MenuItem>
            {enumerations?.allEnums?.vendorTypes.map(option => (
              <MenuItem key={option.id} value={option.id}>
                {option.title}
              </MenuItem>
            ))}
          </TextField>
          <FormControl className={classes.textField} variant="outlined">
            <InputLabel>Designations</InputLabel>
            <Select
              labelId="Designations"
              value={selectedDesignations}
              multiple
              variant="outlined"
              margin="dense"
              className={classes.designationsTextField}
              sx={{ maxWidth: '100px', padding: '30px' }}
              onChange={this.handleDesignationsChange}
              input={<OutlinedInput label="Designations" />}
              renderValue={(selected) => {
                const names = selected.filter(s => s.id !== ALL_DESIGNATIONS.id);
                return names.length === 0 ? <em>All Designations</em> : names.map(s => s.title).join(', ');
              }}
            // renderValue={selectedDesignations => (
            //   <div
            //     style={{
            //       display: 'flex',
            //       flexWrap: 'wrap',
            //       gap: '4px'
            //     }}
            //   >
            //     {/* {selectedDesignations.map(option => (
            //       <Chip
            //         key={option.id}
            //         label={option.title}
            //         onDelete={() => {
            //           const updatedValues = selectedDesignations.filter(v => v.id !== option.id);
            //           this.handleDesignationChange(updatedValues);
            //         }}
            //         onMouseDown={e => {
            //           e.stopPropagation();
            //         }}
            //       />
            //     ))} */}
            //   </div>
            // )}
            >
              <MenuItem value={ALL_DESIGNATIONS}>
                <em>All Designations</em>
              </MenuItem>
              {enumerations?.allEnums?.vendorDesignations.map(opt => {
                if (opt.title !== '') {
                  return (
                    <MenuItem key={opt.id} value={opt}>
                      {opt.title} {/* Display name */}
                    </MenuItem>
                  );
                }
                else {
                  return null;
                }
              }
              )}
            </Select>
          </FormControl>
        </div>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Box sx={{ padding: '10px', display: 'flex', flexDirection: 'row' }}></Box>
          <Button
            color="secondary"
            variant="contained"
            sx={{
              maxHeight: '40px',
              marginRight: '10px',
              marginTop: '8px',
              backgroundColor: '#5D9878',
              '&:hover': { backgroundColor: '#528569' }
            }}
            onClick={() => this.setState({ showCreateVendor: true })}
          >
            {' '}
            Create Partner{' '}
          </Button>
        </Box>
        <div className="px-2">
          <VendorsGrid vendors={vendorSummaries ?? []} isLoading={isLoading} history={history} enums={enumerations.allEnums} />
        </div>
        {enumerations.allEnums && enumerations.allEnums.countries && (
          <CreateVendorDialog
            open={showCreateVendor}
            classes={classes}
            onCancel={() => this.setState({ showCreateVendor: false })}
            history={this.props.history}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    authorizations: { vendors },
    expenses: { vendorSummaries, isLoading },
    enumerations
  } = state;
  return { vendorSummaries, isLoading, vendors, enumerations };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    setPageTitle,
    showToast,
    getTestApiV2,
    getVendors,
    postVendor,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries
  })
)(VendorsView);
